import { useLocation } from 'react-router-dom';
import { ADMIN_BASE_PATH } from '@/config/admin-routes';

const ICP_RECORD_NUMBER = '粤ICP备2026106748号';
const PUBLIC_SECURITY_RECORD_NUMBER = '粤公网安备44030002015442号';
const PUBLIC_SECURITY_RECORD_URL =
  'https://beian.mps.gov.cn/#/query/webSearch?code=44030002015442';
const PUBLIC_SECURITY_BADGE_URL =
  'https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png';

export default function IcpFooter() {
  const { pathname } = useLocation();

  if (pathname.startsWith(ADMIN_BASE_PATH)) {
    return null;
  }

  return (
    <footer className="border-t border-orange-100 bg-[#fffaf5] px-4 py-4 text-center text-xs text-stone-500">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <a
          className="transition-colors hover:text-orange-600"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noreferrer"
        >
          {ICP_RECORD_NUMBER}
        </a>
        <a
          className="inline-flex items-center gap-1 transition-colors hover:text-orange-600"
          href={PUBLIC_SECURITY_RECORD_URL}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={PUBLIC_SECURITY_BADGE_URL}
            alt=""
            aria-hidden="true"
            width="16"
            height="17"
            className="h-[17px] w-4 shrink-0"
          />
          <span>{PUBLIC_SECURITY_RECORD_NUMBER}</span>
        </a>
      </div>
    </footer>
  );
}
